import * as Yup from 'yup';
import { Alerts } from '../../../../../../shared/types/legalProceedings/alerts';

export const initialValues: Alerts = {
    status: '',
    receptionChannel: '',
    typePQR: '',
    receivedThrough: '',
    subtypeDP: '',
    transaction: '',
    name: '',
    active: true,
    observation: '',
    newStatus: '',
};

export const validationSchema = () =>
    Yup.object({
        receptionChannel: Yup.string().required(
            'El canal de recepción es obligatorio'
        ),
        typePQR: Yup.string().required('El tipo PQR es obligatorio'),
        receivedThrough: Yup.string().required('El medio es obligatorio'),
        subtypeDP: Yup.string().required('El subtipo DP es obligatorio'),
        transaction: Yup.string().required('El tramite es obligatorio'),
        status: Yup.string().required('El estado es obligatorio'),
        observation: Yup.string().required('La observación es obligatorio'),
    });
